import { Component, OnInit } from '@angular/core';
import { ModalHelper } from '../../components/modal/modal.helper';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  constructor(private _modal:ModalHelper) {}

  ngOnInit() {};

  public openMessageModal():void {
    this._modal.show("messageModal");
  }

}
